<template>
  <div class="layout-topbar" style="border-bottom: 2px solid var(--primary-color)">
    <!-- Logo -->
    <router-link to="/" class="layout-topbar-logo">
      <template v-if="$store.state.setting?.image_url || logoUrl">
        <img :src="$store.state.setting?.image_url ?? logoUrl" alt="logo" />
      </template>
      <span v-else>{{ $store.state.setting?.app_name ?? 'XETOKO' }}</span>
    </router-link>

    <!-- Hamburger / Mobile Menu -->
    <button class="p-link layout-menu-button layout-topbar-button text-primary" @click="onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>

    <!-- Profile / Topbar Menu Button -->
    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      @click="toggleProfileMenu($event)"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <!-- Topbar Menu -->
    <div class="layout-topbar-menu" :class="topbarMenuClasses">
      <ul
        class="list-none p-0 m-0 lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static"
      >
        <li>
          <a
            class="flex p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors"
          >
            <DarkmodeSwitcherComponent />
          </a>
        </li>

        <li class="border-top-1 surface-border lg:border-top-none">
          <a
            class="flex p-3 lg:px-3 lg:py-2 align-items-center hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors"
            aria-haspopup="true"
            aria-controls="overlay_menu"
            @click="toggleProfileMenu($event)"
          >
            <Avatar
              image="/layout/images/profile/default.jpeg"
              class="mr-3 lg:mr-0"
              style="width: 32px; height: 32px"
              size="xlarge"
              shape="circle"
            />
            <div class="block lg:hidden">
              <div class="text-900 font-medium">{{ users?.name || 'John' }}</div>
              <span class="text-600 font-medium text-sm">Admin</span>
            </div>

            <!-- PrimeVue Menu -->
            <Menu ref="menu" :model="items" :popup="true" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { useLayout } from '@/layout/admin/composables/layout';
import Cookies from 'js-cookie';
import DarkmodeSwitcherComponent from '@/components/_global/DarkmodeSwitcherComponent.vue';
import Menu from 'primevue/menu';  // Correct import for PrimeVue Menu
import Avatar from 'primevue/avatar';  // Correct import for PrimeVue Avatar

export default {
  components: {
    DarkmodeSwitcherComponent,
    Menu,
    Avatar,
  },
  data() {
    const { layoutConfig, onMenuToggle } = useLayout();
    return {
      layoutConfig,
      onMenuToggle,
      topbarMenuActive: false,
      items: [
        { separator: true },
        {
          label: 'Profile',
          items: [
            {
              label: 'Settings',
              icon: 'pi pi-cog',
              command: () => {
                this.$router.push({ name: 'app-settings' });
              },
            },
            {
              label: 'Logout',
              icon: 'pi pi-sign-out',
              command: async () => {
                const token = Cookies.get('x-access-token');
                try {
                  await window.axios.get('/v1/auth/logout', {
                    headers: { Authorization: `Bearer ${token}` },
                  });
                } catch (err) {
                  console.error('logout error', err);
                } finally {
                  Cookies.remove('x-access-token');
                  this.$router.push({ name: 'login' });
                }
              },
            },
          ],
        },
        { separator: true },
      ],
    };
  },
  computed: {
    ...mapState(['users', 'setting']),
    logoUrl() {
      return `/layout/images/${this.layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.png`;
    },
    topbarMenuClasses() {
      return {
        'layout-topbar-menu-mobile-active': this.topbarMenuActive,
      };
    },
  },
  methods: {
    toggleProfileMenu(event) {
      this.$refs.menu.toggle(event);
      this.topbarMenuActive = !this.topbarMenuActive;
    },
  },
};
</script>

<style scoped lang="scss">
.layout-topbar .layout-topbar-logo img {
  height: 2.5rem;
  margin-right: 0.5rem;
}
a {
  text-decoration: none;
}
</style>